module.exports = __webpack_public_path__ + "static/media/mnb2.d0bed5e2.png";